import { create } from 'zustand';

import type { MedicalStaff } from '../types/medical-staff.types';

// Coordinates between row-click (trigger) and the page-level edit panel (consumer).
// Holds the full MedicalStaff object so the panel doesn't need a second fetch — the
// list query already supplies it.
interface MedicalStaffEditState {
  editing: MedicalStaff | null;
  open: (staff: MedicalStaff) => void;
  // Refresh the panel's row after a mutation that updates it in place
  // (e.g. reject-withdraw clears `withdrawRequest` but keeps the panel open).
  // List queries get invalidated separately; this is for the panel only.
  setEditing: (staff: MedicalStaff) => void;
  close: () => void;
}

export const useMedicalStaffEditStore = create<MedicalStaffEditState>((set) => ({
  editing: null,
  open: (staff) => set({ editing: staff }),
  setEditing: (staff) => set({ editing: staff }),
  close: () => set({ editing: null }),
}));
